import { sortingHelper, Filters } from '@ui/src';
import { AccountTransaction, CardsTransactions } from '../../types';

export const accountTransactionFiltersHelper = (
  items: AccountTransaction[],
  sortKey: string,
  direction: 'asc' | 'desc',
  filters: Filters,
): AccountTransaction[] => {
  let nextItems: AccountTransaction[] = items;

  Object.keys(filters).map((fieldName) => {
    if (filters[fieldName]) {
      nextItems = nextItems.filter((item) => {
        let value;

        if (fieldName === 'date') {
          const date = new Date(item[fieldName])?.getTime();

          if (filters[fieldName]?.value.length > 1) {
            const dateTo = new Date(filters[fieldName].value[1]);

            dateTo.setHours(23);
            dateTo.setMinutes(59);
            dateTo.setSeconds(59);

            value =
              date >= new Date(filters[fieldName].value[0]).getTime() &&
              date <= dateTo.getTime();
          } else {
            value = date >= new Date(filters[fieldName].value[0]).getTime();
          }
        } else if (Array.isArray(filters[fieldName])) {
          value = filters[fieldName].value.includes(
            item[fieldName as keyof AccountTransaction] as string,
          );
        } else {
          value = (item[fieldName as keyof AccountTransaction] as string)
            .toLowerCase()
            .includes(filters[fieldName].value[0].toLowerCase());
        }

        return value;
      });
    }

    return nextItems;
  });

  if (sortKey && direction) {
    nextItems = sortingHelper<AccountTransaction>(
      nextItems,
      sortKey,
      direction,
    );
  }

  return nextItems;
};

export const cardsTransactionFiltersHelper = (
  items: CardsTransactions[],
  sortKey: string,
  direction: 'asc' | 'desc',
  filters: Filters,
): CardsTransactions[] => {
  let nextItems: CardsTransactions[] = items;

  Object.keys(filters).map((fieldName) => {
    if (filters[fieldName]) {
      nextItems = nextItems.filter((item) => {
        let value;

        if (fieldName === 'date') {
          const date = new Date(item[fieldName])?.getTime();

          if (filters[fieldName]?.value.length > 1) {
            const dateTo = new Date(filters[fieldName].value[1]);

            dateTo.setHours(23);
            dateTo.setMinutes(59);
            dateTo.setSeconds(59);

            value =
              date >= new Date(filters[fieldName].value[0]).getTime() &&
              date <= dateTo.getTime();
          } else {
            value = date >= new Date(filters[fieldName].value[0]).getTime();
          }
        } else if (Array.isArray(filters[fieldName])) {
          value = filters[fieldName].value.includes(
            item[fieldName as keyof CardsTransactions] as string,
          );
        } else {
          value = (item[fieldName as keyof CardsTransactions] as string)
            .toLowerCase()
            .includes(filters[fieldName].value[0].toLowerCase());
        }

        return value;
      });
    }

    return nextItems;
  });

  if (sortKey && direction) {
    nextItems = sortingHelper<CardsTransactions>(nextItems, sortKey, direction);
  }

  return nextItems;
};
